const normalizeCsv = (value) =>
  String(value || '')
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);

const IMPLICIT_PLATFORM_HOSTS = ['app.fleetcontrolcloud.com', 'platform.fleetcontrolcloud.com'];

export const isPlatformStandaloneMode = () => {
  const forced = String(process.env.REACT_APP_PLATFORM_STANDALONE || '').trim().toLowerCase();
  if (forced === '1' || forced === 'true') {
    return true;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  const host = String(window.location.hostname || '').trim().toLowerCase();
  const configuredHosts = normalizeCsv(process.env.REACT_APP_PLATFORM_HOSTS);

  if (configuredHosts.length > 0) {
    return configuredHosts.includes(host) || IMPLICIT_PLATFORM_HOSTS.includes(host);
  }

  return IMPLICIT_PLATFORM_HOSTS.includes(host) || host === 'admin.fleetcontrolcloud.com' || host.startsWith('admin.');
};
